module.exports = __webpack_public_path__ + "media/images/athletes/1976-440e19c2677703465c79b02a1e68df5d.png";